<template>
  <div class="ai_color_swatches mb-4">
    <div v-for="(item, index) in colorsList" :key="index"
      class="rounded_10 d-flex align-items-center p-3 cursor_pointer" @click.once="eachColor(item, index)"
      :style="[index === selectedIndex ? { border: '1px solid' + primaryColor } : { border: '0px' }]"
      :class="[{ 'custom_box_shadow bg-white': !isGradient }, { 'transparent-bgcolor-light': isGradient }]">
      <div class="color_selector custom_box_shadow" :style="{
        background:
          (isEnableExtGenericColors ? item.colorDescription : '#' + item.colorCode) +
          '!important',
      }" @click="selectedColor(item, index)" />
      <div class="ml-2 text-truncate _theme_font_bold" :class="{ gradient_text_white: isGradient }"
        :title="item.colorDescription">
        {{ item.colorDescription }}
      </div>
    </div>
  </div>

</template>
<script>
import { ChatWidgetService } from '../../../../Services/ChatWidgetService/ChatWidgetService';


export default {
  props: ["botResponse", "isWaitingForResponse", "isLastIndex", "chatThemeSettings"],
  data() {
    return {
      selectedColorName: {},
      selectedIndex: "",
      colorsList: [],
      primaryColor: window.primaryColor,
    }
  },
  mounted() {
    this.colorsList = this.botResponse?.component?.value?.colorCodeDto;
    if (this.isGradient) {
      this.primaryColor = '#fff';
    }
  },
  computed: {
    isGradient() {
      return this.chatThemeSettings?.isGradient || false;
    },
    isEnableExtGenericColors() {
      return this.botResponse?.component?.value?.enableExtGenericColors;
    },
  },
  methods: {
    eachColor(item, index) {
      let specialObject = { TvmComponentRequest: item };
      ChatWidgetService.postTvmMessage(item.colorDescription, null, this.botResponse?.component?.submitFlow,
        this.botResponse?.component?.submitAction, specialObject);
      this.selectedIndex = index;
    }
  }
}
</script>
<style lang="less" scoped>
.ai_color_swatches {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 15px;

  .color_selector {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    cursor: pointer;
  }
}
</style>
